/* eslint-disable import/prefer-default-export */
const config = {
    selectors: {
        root: '.drag-bar',
        barItems: '.drag-bar__bar-items',
        barItem: '.drag-bar__bar-item',
        controlBtn: '.drag-bar__control-btn',
        next: '.drag-bar__control-next',
        prev: '.drag-bar__control-prev',
    },
    classNames: {
        itemActive: 'drag-bar__bar-item--active',
        dotted: 'drag-bar--dotted',
        prevDisabled: 'drag-bar__control-prev--disabled',
        nextDisabled: 'drag-bar__control-next--disabled',
        itemLine: 'drag-bar__bar-item-line',
    },
    dataAttributes: {
        
    },
    easeTime: 0.5,
};

export class DragBar {
    static getClassname() {
        return config.selectors.root;
    }

    static createHtml(itemCount, slidesToShow=1) {
        return DragBar._generateBar(new Array(itemCount), slidesToShow);
    }

    static createLabeledHtml(items, slidesToShow=1) {
        return DragBar._generateBar(items, slidesToShow);
    }

    static init($rootElement, onChangeCallback) {
        const $elements = DragBar._getDomElements($rootElement);
       
        DragBar._addEventListeners($elements, onChangeCallback);
    }

    static _getDomElements($rootElement) {
        return {
            $root: $rootElement,
            $barItems: $rootElement.find(config.selectors.barItems),
            $barItem: $rootElement.find(config.selectors.barItem),
            $button: $rootElement.find(config.selectors.controlBtn),
            $next: $rootElement.find(config.selectors.next),
            $prev: $rootElement.find(config.selectors.prev),
        };
    }

    static _getClickOffset(event, $elements) {
        return event.clientX - $elements.$button.offset().left;
    }

    static setIndex($el, index) {
        const $elements = DragBar._getDomElements($el);

        DragBar._syncOnIndex($elements, index);
    }

    static _addEventListeners($elements, onChangeCallback) {
        const buttonOffset = $elements.$button.offset().left;
        let mouseDown = false;
        let canUpdate = false;

        $elements.$button.on('mousedown', (e) => {
            canUpdate = true;
            const clickOffset = DragBar._getClickOffset(e, $elements);
            DragBar._registerMousemoveListener($elements, clickOffset, canUpdate, onChangeCallback);
            mouseDown = true;
        });

        $elements.$barItem.on('click', function (e) {
            const currentIndex = DragBar._getCurrentIndex($elements);
            const buttonLeft = DragBar._calculateNewButtonLeft($elements, currentIndex);
            let index = $(this).data('index');

            if(index === currentIndex) {
                if(buttonLeft < e.offsetX) {
                    index++;
                } else {
                    index--;
                }
                
                DragBar._syncOnIndex($elements, index);
                onChangeCallback(index);
            } else {
                DragBar._syncOnIndex($elements, index);
                onChangeCallback(index);
            }
            
        });

        $elements.$barItem.on('keydown', function (e) {
            if (e.keyCode !== 13) return;

            const index = $(this).data('index');
            DragBar._syncOnIndex($elements, index);
            onChangeCallback(index);
        });

        $elements.$prev.on('click', () => {
            const chunkIndex = DragBar._determineChunkIndex($elements, buttonOffset) - 1;
            DragBar._syncOnIndex($elements, chunkIndex);
            onChangeCallback(chunkIndex);
        });

        $elements.$prev.on('keydown', () => {
            if (e.keyCode !== 13) return;

            const chunkIndex = DragBar._determineChunkIndex($elements, buttonOffset) - 1;
            DragBar._syncOnIndex($elements, chunkIndex);
            onChangeCallback(chunkIndex);
        });

        $elements.$next.on('click', () => {
            const chunkIndex = DragBar._determineChunkIndex($elements, buttonOffset) + 1;
            DragBar._syncOnIndex($elements, chunkIndex);
            onChangeCallback(chunkIndex);
        });

        $elements.$next.on('keydown', () => {
            if (e.keyCode !== 13) return;

            const chunkIndex = DragBar._determineChunkIndex($elements, buttonOffset) + 1;
            DragBar._syncOnIndex($elements, chunkIndex);
            onChangeCallback(chunkIndex);
        });

        $(window).on('mouseup', (e) => {
            if (mouseDown) {
                mouseDown = false;
                canUpdate = false;
                const chunkIndex = DragBar._determineChunkIndex($elements, buttonOffset);
                DragBar._unregisterMousemoveListener();
                DragBar._syncOnIndex($elements, chunkIndex);
                onChangeCallback(chunkIndex);
            }
        });
    }

    static _registerMousemoveListener($elements, clickOffset, canUpdate, onChangeCallback) {
        let prevX = $elements.$button.offset();
        let prevIndex = 0;

        $(window).on('mousemove', (e) => {
            if (!canUpdate) return;

            let x = e.clientX;

            if (prevX !== 0) {
                const bar = $elements.$barItem;
                let newX = x - $elements.$root.offset().left - clickOffset;

                if (newX < 0) newX = 0;
                if (newX > bar.width() * bar.length - $elements.$button.width()) {
                    newX = bar.width() * bar.length - $elements.$button.width();
                }

                $elements.$button.css('left', newX);

                const index = DragBar._determineChunkIndex($elements);

                if (index !== prevIndex) {
                    onChangeCallback(index);
                    prevIndex = index;
                }
            }

            prevX = x;
        });
    }

    static _syncOnIndex($elements, index) {
        const left = DragBar._calculateNewButtonLeft($elements, index)
        DragBar._moveButton($elements, left);

        $elements.$barItem.removeClass(config.classNames.itemActive);
        $($elements.$barItem[index]).addClass(config.classNames.itemActive);

        if (index !== 0) $elements.$prev.removeClass(config.classNames.prevDisabled);
        if (index === 0) $elements.$prev.addClass(config.classNames.prevDisabled);

        if (index !== $elements.$barItems[0].children.length - 1) $elements.$next.removeClass(config.classNames.nextDisabled);
        if (index === $elements.$barItems[0].children.length - 1) $elements.$next.addClass(config.classNames.nextDisabled);
    }

    static _calculateNewButtonLeft($elements, index) {
        let left;

        if (DragBar._isAtMinBounds(index)) left = 0;
        else if (DragBar._isAtMaxBounds($elements, index))
            left = ($elements.$barItem.width() * $elements.$barItem.length) - $elements.$button.width();
        else left = (index * $elements.$barItem.width() );

        // in normal mode, we want to ease the button to the middle of the item when we are not at Bounds
        if (!DragBar._isAtBounds($elements, index) && !$elements.$root.hasClass(config.classNames.dotted)) {
            left += $elements.$barItem.width() / 2 - $elements.$button.width() / 2;
        }

        return left;
    }

    static _moveButton($elements, left) {
        $elements.$button.css('transition', `left ${config.easeTime}s ease`);
        $elements.$button.css('left', left);

        setTimeout(() => {
            $elements.$button.css('transition', 'none');
        }, config.easeTime * 1000);
    }

    static _alignButtonAtEnd($elements) {
        $elements.$button.css('transition', `right ${config.easeTime}s ease`);
        $elements.$button.css('right', 0);
        $elements.$button.css('left', 'auto');

        setTimeout(() => {
            $elements.$button.css('transition', 'none');
        }, config.easeTime * 1000);
    }

    static _alignButtonAtStart($elements) {
        $elements.$button.css('transition', `left ${config.easeTime}s ease`);
        $elements.$button.css('left', 0);
        $elements.$button.css('right', 'auto');

        setTimeout(() => {
            $elements.$button.css('transition', 'none');
        }, config.easeTime * 1000);
    }

    static _unregisterMousemoveListener() {
        $(window).off('mousemove');
    }

    static _determineChunkIndex($elements) {
        const offset = $elements.$root.offset().left;
        const currentLeft = $elements.$button.offset().left - offset;
        const unroundedGoTo = currentLeft / $elements.$barItem.width();

        return Math.round(unroundedGoTo);
    }

    static _isAtBounds($elements, index) {
        return this._isAtMinBounds(index) || this._isAtMaxBounds($elements, index);
    }

    static _isAtMinBounds(index) {
        return index <= 0;
    }

    static _isAtMaxBounds($elements, index) {
        return index >= $elements.$barItem.length - 1;
    }

    static _getCurrentIndex($elements) {
        let index = 0;

        $elements.$barItem.each((i, element) => {
            if($(element).hasClass(config.classNames.itemActive)) {
                index = i;
            }
        });

        return index;
    }

    /*
        SECTION TEMPLATE
    */

    static _generateBar(items, slidesToShow) {
        const labeled = items[0] && items[0] !== '' || false;
        
        return `
            <div class="drag-bar${labeled ? ' drag-bar--dotted' : ''}">
                <div class="drag-bar__control-btn" aria-label="dragger" data-hover="true" tabindex="0">
                    <div class="drag-bar__control-btn-prev"></div>
                    <div class="drag-bar__control-btn-next"></div>
                </div>
                <div class="drag-bar__bar-items">
                    ${DragBar._generateBarItems(items, slidesToShow)}
                </div>
                <div class="drag-bar__control-arrows">
                    <div class="drag-bar__control-arrows-inner">
                        <div class="drag-bar__control-prev drag-bar__control-prev--disabled icon-TickCircleFullArrowBackward1" tabindex="0" aria-label="prev"></div>
                        <div class="drag-bar__control-next icon-TickCircleFullArrowForward1" tabindex="0" aria-label="next"></div>
                    </div>
                </div>
            </div>
        `;
    }

    static _generateBarItems(items, slidesToShow) {
        let html = '';
        //-2/-1 because bar carousel shows 3 slides 
        // let itemlength=$('.bar-carousel__bar').children() ? items.length-2:  items.length;
        // items.length/slidesToShow
       
        for (let index = 0; index < Math.ceil(items.length/slidesToShow); index++) {
            html += `
                <div class="drag-bar__bar-item${index === 0 ? ' drag-bar__bar-item--active' : ''}" data-index="${index}" tabindex="0">
                    ${items[index] ? DragBar._generateItemLabel(items[index]) : ''}
                    <span class="drag-bar__bar-item-line"></span>
                </div>
            `;
        }

        return html;
    }

    static _generateItemLabel(label) {
        return `
            <span class="drag-bar__item-label">${label}</span>
        `;
    }
}
